// extracted by mini-css-extract-plugin
module.exports = {"pintxo-drag-handler":"Drawer_pintxo-drag-handler__1wPlc","pintxo-drag-handler--dragging":"Drawer_pintxo-drag-handler--dragging___1_0Q"};